import { useContext, useEffect, useState } from "react";
import { Context } from "../../components/Context";
import { COUNTRY_SEARCH, fetchData, GET_ALL_NRIS_TALK_LIST, STATE_SEARCH } from "../../components/Service";
import moment from "../../../node_modules/moment/moment";
import { Link, useLocation } from "../../../node_modules/react-router-dom/dist/index";
import { scrollTop } from "../../components/Helper";

const SearchResults = () => {
	const location = useLocation();
	const [data, setData] = useState(location?.state?.search_result);
	const [keyword] = useState(localStorage.getItem("_nrissearch"));
	const [context] = useContext(Context);
	const [pageUrl, setPageUrl] = useState();
	const [notFound, setNotFound] = useState(false);

	const searchResult = (country_id) => {
		let payload = {
			country_id: country_id,
			keyword: keyword,
		};

		if (context?.stateView) {
			payload = { ...payload, state_id: context?.stateId };
		}
		fetchData(pageUrl ? pageUrl : context?.stateView ? STATE_SEARCH : COUNTRY_SEARCH, "POST", payload, false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setData(res?.data);
			} else {
				setNotFound(true);
				setData(res?.data);
			}
		});
	};

	useEffect(() => {
		scrollTop();
		if (!data && context?.countryId) {
			setPageUrl();
			searchResult(context?.countryId);
		}
	}, [context?.countryId, keyword]);

	useEffect(() => {
		scrollTop();
		if (context?.countryId) {
			searchResult(context?.countryId);
		}
	}, [pageUrl]);

	return (
		<div class="col-lg-12">
			<div class="card card-forum">
				<div class="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 class="text-white d-flex mb-0 py-2">Search Results</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white p-1 body-minh">
					<table class="table table-striped table-responsive">
						<thead>
							<tr>
								<th scope="col">Title</th>
								<th scope="col">Created On</th>
							</tr>
						</thead>
						<tbody>
							{data?.data &&
								data?.data?.length > 0 &&
								data?.data?.map((item) => (
									<tr key={item.id}>
										<td>
											<Link to={`/business/details/${item.id}`} state={{ state_id: item.state_id }}>
												{item.image && <img src={item.image} alt={item.title} className="p-1 me-2 rounded" width={50} height={50} />}
												{item.name}
											</Link>
										</td>
										<td>{item.created_at ? moment(item.created_at).format("DD-MMM-YYYY") : ""}</td>
									</tr>
								))}
							{notFound && (
								<tr>
									<td className="text-center h6 text-danger py-3" colSpan={4}>
										No Records Found!
									</td>
								</tr>
							)}
						</tbody>
					</table>
					{data?.data && (
						<nav className="pt-3">
							<ul className="pagination justify-content-end">
								<li className={`page-item ${data.prev_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(data.prev_page_url)}>
										<span aria-hidden="true">&laquo;</span> Previous
									</button>
								</li>
								<li className={`page-item ${data.next_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(data.next_page_url)}>
										Next <span aria-hidden="true">&raquo;</span>
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
			</div>
		</div>
	);
};

export default SearchResults;
